interface ContainerProps {
  children: React.ReactNode;
}

export default function Container({ children }: ContainerProps) {
  return <div className="md:border md:rounded-xl md:p-6">{children}</div>
}
